/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import ViewMultipleQuotesPage from './ViewMultipleQuotesPage';
export default ViewMultipleQuotesPage;
